import Scene from "./Scene";
import Carousel from "../ui/carousel/Carousel";
import common from "../common";
import {base64ToArrayBuffer, calcLeftEdge, isCordova, saveImage, translate} from "../utils";
import GalleryCarousel from "../ui/carousel/GalleryCarousel";
import UICarousel from "../ui/UICarousel";
import GalleryItem from "../ui/carousel/GalleryItem";
import SceneTitlePanel from "../ui/SceneTitlePanel";

export default class GalleryScene extends Scene {

    static fetchImageEntries(path, callback) {
        window.resolveLocalFileSystemURL(path,
            function (fileSystem) {
                var reader = fileSystem.createReader();
                reader.readEntries(
                    function (entries) {
                        console.log(entries);

                        entries = entries.filter((entry) => {
                            return entry.name.includes(common.config.save.app_hash);
                        });

                        callback && callback.call(this, entries);
                    },
                    function (err) {
                        console.log(err);
                    }
                );
            }, function (err) {
                console.log(err);
            }
        );
    }

    constructor() {
        super();

        this._scrollSpeed = -15;

        this._textures = [];

        this._bg = new PIXI.TilingSprite(P3.assets.texture("bg_main"), common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this.addChild(this._bg);

        this._bg.tilePosition = common.tilePosition;

        this._carousel = new UICarousel();
        this._carousel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this._carousel);

        if (PIXI.utils.isMobile.android.device) {
            // this.listFilesInDirectory("file:///storage/emulated/0/Download");
            GalleryScene.fetchImageEntries("file:///storage/emulated/0/Download", (entries) => {
                console.log(entries);
                this.loadGalleryImages(entries);
            })
        } else if (PIXI.utils.isMobile.apple.device) {
            // const storageLocation = cordova.file.syncedDataDirectory;
            const storageLocation = cordova.file.documentsDirectory;
            GalleryScene.fetchImageEntries(storageLocation, (entries) => {
                console.log(entries);
                this.loadGalleryImages(entries);
            })
        }

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_out");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.icon = P3.assets.texture("icon_back");

        this._backButton = new P3.Button(states);
        this._backButton.signals.click.add(this._onBackButtonClick, this);
        this._backButton.clickSoundName = "sfx_click";
        this.addChild(this._backButton);

        this._sceneTitle = new SceneTitlePanel(translate("gallery"));
        this._sceneTitle.position.set(common.STAGE_WIDTH / 2, 90);
        this.addChild(this._sceneTitle);
    }

    async loadGalleryImages(entries) {
        const promises = [];

        if (PIXI.utils.isMobile.android.device) {
            for (let i = 0; i < entries.length; i++) {
                const entry = entries[i];
                promises.push(PIXI.Texture.fromURL(entry.toURL()));
            }
        } else {
            for (let i = 0; i < entries.length; i++) {
                const entry = entries[i];
                promises.push(PIXI.Texture.fromURL(window.WkWebView.convertFilePath(entry.toURL())));
            }
        }

        const textures = await Promise.all(promises);

        const items = [];
        for (let i = 0; i < textures.length; i++) {
            const item = new GalleryItem(textures[i]);
            items.push(item);
        }

        this._carousel.init(items);
        this._carousel.animateIn();

        this._textures = textures;
    }

    destroy() {
        super.destroy();

        for (let i = 0; i < this._textures.length; i++) {
            const t = this._textures[i];
            t.destroy(true);
        }
    }

    resize() {
        super.resize();
        this._backButton.position.set(calcLeftEdge() + 90, 90);
    }

    update(dt = window.deltaTime) {
        super.update();
        common.tilePosition.x += this._scrollSpeed * dt;
        common.tilePosition.y -= this._scrollSpeed * dt;

        if (common.tilePosition.x < 0) {
            common.tilePosition.x = common.STAGE_WIDTH;
        }
        if (common.tilePosition.y > common.STAGE_HEIGHT) {
            common.tilePosition.y = 0;
        }

        this._bg.tilePosition = common.tilePosition.clone();
        this._carousel.update(dt);
    }

    _onBackButtonClick() {
        this.signals.previous.dispatch();
    }
}